// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_us-0";
export var checkoutRateBadgeLink = "_us-1";